"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Remove(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("rect", { width: "14", height: "2", x: "1", y: "7", fill: "currentColor", fillRule: "evenodd" })));
}
exports.default = Remove;
//# sourceMappingURL=Remove.js.map